import React from 'react';
import { UnauthorizedErrorPage } from '../../components/error-pages/unauthorized';

export const NotAuthorizedPage: React.FC = () => <UnauthorizedErrorPage />;
